export const ModuleIcons = {
  'Entregas': (
    <svg viewBox="0 0 100 100" fill="none">
      <defs>
        <linearGradient id="truckGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4CAF50"/>
          <stop offset="100%" stopColor="#2E7D32"/>
        </linearGradient>
      </defs>
      <rect x="10" y="30" width="50" height="25" rx="3" fill="url(#truckGrad)"/>
      <rect x="60" y="35" width="25" height="20" rx="2" fill="url(#truckGrad)"/>
      <circle cx="25" cy="65" r="8" fill="#333"/>
      <circle cx="70" cy="65" r="8" fill="#333"/>
      <circle cx="25" cy="65" r="5" fill="#666"/>
      <circle cx="70" cy="65" r="5" fill="#666"/>
      <rect x="15" y="35" width="35" height="15" fill="#81C784"/>
      <path d="M20 20 L30 10 L40 20 Z" fill="#FF9800"/>
      <circle cx="30" cy="15" r="3" fill="#FFC107"/>
    </svg>
  ),
  
  'Artículos a entregar': (
    <svg viewBox="0 0 100 100" fill="none">
      <defs>
        <linearGradient id="boxGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF9800"/>
          <stop offset="100%" stopColor="#F57C00"/>
        </linearGradient>
      </defs>
      <rect x="15" y="25" width="25" height="25" rx="3" fill="url(#boxGrad)"/>
      <rect x="45" y="25" width="25" height="25" rx="3" fill="url(#boxGrad)"/>
      <rect x="15" y="55" width="25" height="25" rx="3" fill="url(#boxGrad)"/>
      <rect x="45" y="55" width="25" height="25" rx="3" fill="url(#boxGrad)"/>
      <path d="M20 30 L35 30 M20 35 L30 35" stroke="white" strokeWidth="2"/>
      <path d="M50 30 L65 30 M50 35 L60 35" stroke="white" strokeWidth="2"/>
      <circle cx="85" cy="15" r="8" fill="#4CAF50"/>
      <path d="M82 15 L84 17 L88 13" stroke="white" strokeWidth="2" fill="none"/>
    </svg>
  ),
  
  'Asignación Transportistas': (
    <svg viewBox="0 0 100 100" fill="none">
      <defs>
        <linearGradient id="assignGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#2196F3"/>
          <stop offset="100%" stopColor="#1565C0"/>
        </linearGradient>
      </defs>
      <circle cx="25" cy="25" r="12" fill="url(#assignGrad)"/>
      <circle cx="75" cy="25" r="12" fill="url(#assignGrad)"/>
      <circle cx="50" cy="75" r="12" fill="url(#assignGrad)"/>
      <path d="M25 25 L50 75" stroke="#4CAF50" strokeWidth="3"/>
      <path d="M75 25 L50 75" stroke="#4CAF50" strokeWidth="3"/>
      <rect x="45" y="70" width="10" height="10" rx="2" fill="white"/>
      <circle cx="25" cy="25" r="6" fill="white"/>
      <circle cx="75" cy="25" r="6" fill="white"/>
      <path d="M22 25 L28 25 M25 22 L25 28" stroke="url(#assignGrad)" strokeWidth="2"/>
    </svg>
  ),
  
  'Calendario': (
    <svg viewBox="0 0 100 100" fill="none">
      <defs>
        <linearGradient id="calGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#E91E63"/>
          <stop offset="100%" stopColor="#AD1457"/>
        </linearGradient>
      </defs>
      <rect x="15" y="20" width="70" height="60" rx="5" fill="url(#calGrad)"/>
      <rect x="20" y="35" width="60" height="40" rx="3" fill="white"/>
      <rect x="20" y="10" width="8" height="20" rx="4" fill="#666"/>
      <rect x="72" y="10" width="8" height="20" rx="4" fill="#666"/>
      <rect x="25" y="40" width="8" height="8" rx="1" fill="url(#calGrad)"/>
      <rect x="36" y="40" width="8" height="8" rx="1" fill="#E0E0E0"/>
      <rect x="47" y="40" width="8" height="8" rx="1" fill="#E0E0E0"/>
      <rect x="58" y="40" width="8" height="8" rx="1" fill="#4CAF50"/>
      <circle cx="62" cy="44" r="2" fill="white"/>
    </svg>
  ),
  
  'Pedidos por transportista': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2.5-9H18V0h-2v2H8V0H6v2H4.5C3.11 2 2 3.11 2 4.5v15C2 20.89 3.11 22 4.5 22h15c1.39 0 2.5-1.11 2.5-2.5v-15C22 3.11 20.89 2 19.5 2z"/>
    </svg>
  ),
  
  'Pedidos': (
    <svg viewBox="0 0 100 100" fill="none">
      <defs>
        <linearGradient id="orderGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#9C27B0"/>
          <stop offset="100%" stopColor="#6A1B9A"/>
        </linearGradient>
      </defs>
      <rect x="20" y="15" width="60" height="70" rx="5" fill="url(#orderGrad)"/>
      <rect x="25" y="25" width="50" height="55" rx="3" fill="white"/>
      <rect x="30" y="30" width="40" height="4" rx="2" fill="url(#orderGrad)"/>
      <rect x="30" y="40" width="30" height="3" rx="1" fill="#E0E0E0"/>
      <rect x="30" y="47" width="35" height="3" rx="1" fill="#E0E0E0"/>
      <rect x="30" y="54" width="25" height="3" rx="1" fill="#E0E0E0"/>
      <circle cx="75" cy="25" r="8" fill="#4CAF50"/>
      <path d="M72 25 L74 27 L78 23" stroke="white" strokeWidth="2" fill="none"/>
    </svg>
  ),
  
  'Mapa de Pedidos': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.1"/>
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="currentColor"/>
      <circle cx="12" cy="9" r="2.5" fill="white"/>
      <circle cx="8" cy="6" r="1" fill="currentColor" opacity="0.6"/>
      <circle cx="16" cy="7" r="1" fill="currentColor" opacity="0.6"/>
      <circle cx="6" cy="12" r="1" fill="currentColor" opacity="0.4"/>
      <path d="M2 20h20v1H2z" fill="currentColor" opacity="0.3"/>
    </svg>
  ),
  
  'Comisiones': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.1"/>
      <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z" fill="currentColor"/>
      <circle cx="6" cy="6" r="1" fill="currentColor" opacity="0.4"/>
      <circle cx="18" cy="8" r="1" fill="currentColor" opacity="0.4"/>
      <circle cx="20" cy="16" r="1" fill="currentColor" opacity="0.4"/>
    </svg>
  ),
  
  'Tarifas transportistas': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg>
  ),
  
  'Tarifas': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"/>
    </svg>
  ),
  
  'Clientes': (
    <svg viewBox="0 0 100 100" fill="none">
      <defs>
        <linearGradient id="clientGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00BCD4"/>
          <stop offset="100%" stopColor="#0097A7"/>
        </linearGradient>
      </defs>
      <circle cx="50" cy="35" r="15" fill="url(#clientGrad)"/>
      <ellipse cx="50" cy="75" rx="25" ry="15" fill="url(#clientGrad)"/>
      <circle cx="50" cy="35" r="10" fill="white"/>
      <circle cx="47" cy="32" r="2" fill="url(#clientGrad)"/>
      <circle cx="53" cy="32" r="2" fill="url(#clientGrad)"/>
      <path d="M45 40 Q50 43 55 40" stroke="url(#clientGrad)" strokeWidth="2" fill="none"/>
      <circle cx="25" cy="25" r="8" fill="#E0E0E0"/>
      <circle cx="75" cy="25" r="8" fill="#E0E0E0"/>
      <rect x="40" y="65" width="20" height="8" rx="4" fill="white"/>
    </svg>
  ),
  
  'Asignación de Leads': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-1 16H9V7h9v14z"/>
    </svg>
  ),
  
  'Gestión de Leads': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.5 6L12 10.5 8.5 8 12 5.5 15.5 8zM12 19c-3.87 0-7-3.13-7-7 0-.84.16-1.65.43-2.4L12 13l6.57-3.4c.27.75.43 1.56.43 2.4 0 3.87-3.13 7-7 7z"/>
    </svg>
  ),
  
  'Usuarios': (
    <svg viewBox="0 0 100 100" fill="none">
      <defs>
        <linearGradient id="userGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#673AB7"/>
          <stop offset="100%" stopColor="#512DA8"/>
        </linearGradient>
      </defs>
      <circle cx="50" cy="30" r="12" fill="url(#userGrad)"/>
      <ellipse cx="50" cy="70" rx="20" ry="12" fill="url(#userGrad)"/>
      <circle cx="25" cy="25" r="8" fill="#E0E0E0"/>
      <circle cx="75" cy="25" r="8" fill="#E0E0E0"/>
      <ellipse cx="25" cy="60" rx="12" ry="8" fill="#E0E0E0"/>
      <ellipse cx="75" cy="60" rx="12" ry="8" fill="#E0E0E0"/>
      <circle cx="50" cy="30" r="8" fill="white"/>
      <rect x="42" y="62" width="16" height="6" rx="3" fill="white"/>
    </svg>
  ),
  
  'Comerciales': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H16c-.8 0-1.54.37-2 1l-3.72 5.6L8.5 11.5C7.85 10.85 6.8 10.85 6.15 11.5s-.7 1.65 0 2.3L9 16.64V22h2v-4.5l-1.5-1.5L12 14l2.54 1.27c.24.12.5.18.76.18H18v6h2z"/>
    </svg>
  ),
  
  'Transportistas': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.22.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
    </svg>
  ),
  
  'Prefijos Transportistas': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
    </svg>
  ),
  
  'Productos': (
    <svg viewBox="0 0 100 100" fill="none">
      <defs>
        <linearGradient id="prodGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF5722"/>
          <stop offset="100%" stopColor="#D84315"/>
        </linearGradient>
      </defs>
      <rect x="20" y="30" width="60" height="50" rx="5" fill="url(#prodGrad)"/>
      <rect x="25" y="35" width="50" height="40" rx="3" fill="white"/>
      <rect x="35" y="20" width="30" height="15" rx="3" fill="url(#prodGrad)"/>
      <circle cx="35" cy="45" r="4" fill="url(#prodGrad)"/>
      <circle cx="50" cy="45" r="4" fill="url(#prodGrad)"/>
      <circle cx="65" cy="45" r="4" fill="url(#prodGrad)"/>
      <rect x="30" y="55" width="40" height="3" rx="1" fill="#E0E0E0"/>
      <rect x="30" y="62" width="30" height="3" rx="1" fill="#E0E0E0"/>
      <path d="M40 27 L60 27" stroke="white" strokeWidth="3"/>
    </svg>
  ),
  
  'Variantes de Producto': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
    </svg>
  ),
  
  'Productos Especiales': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
    </svg>
  ),
  
  'Eventos': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
    </svg>
  ),
  
  'Canales Telegram': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/>
    </svg>
  ),
  
  'Logs': (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
    </svg>
  ),
  
  'Ajustes': (
    <svg viewBox="0 0 100 100" fill="none">
      <defs>
        <linearGradient id="settGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#607D8B"/>
          <stop offset="100%" stopColor="#455A64"/>
        </linearGradient>
      </defs>
      <circle cx="50" cy="50" r="30" fill="url(#settGrad)"/>
      <circle cx="50" cy="50" r="20" fill="white"/>
      <circle cx="50" cy="50" r="8" fill="url(#settGrad)"/>
      <rect x="45" y="15" width="10" height="15" rx="2" fill="url(#settGrad)"/>
      <rect x="45" y="70" width="10" height="15" rx="2" fill="url(#settGrad)"/>
      <rect x="15" y="45" width="15" height="10" rx="2" fill="url(#settGrad)"/>
      <rect x="70" y="45" width="15" height="10" rx="2" fill="url(#settGrad)"/>
      <circle cx="50" cy="50" r="4" fill="white"/>
    </svg>
  )
};

export const getModuleDescription = (moduleName) => {
  const descriptions = {
    'Entregas': 'Gestiona y supervisa todas las entregas pendientes y completadas',
    'Artículos a entregar': 'Lista detallada de productos por entregar organizados por transportista',
    'Asignación Transportistas': 'Asigna pedidos a transportistas disponibles',
    'Calendario': 'Vista de calendario con entregas y eventos programados',
    'Pedidos por transportista': 'Organiza pedidos según el transportista asignado',
    'Pedidos': 'Gestión completa de pedidos de clientes',
    'Mapa de Pedidos': 'Visualización geográfica de pedidos y rutas',
    'Comisiones': 'Cálculo y gestión de comisiones de ventas',
    'Tarifas transportistas': 'Configuración de tarifas para transportistas',
    'Tarifas': 'Gestión general de tarifas del sistema',
    'Clientes': 'Base de datos y gestión de clientes',
    'Asignación de Leads': 'Distribución de leads entre comerciales',
    'Gestión de Leads': 'Seguimiento y conversión de leads',
    'Usuarios': 'Administración de usuarios del sistema',
    'Comerciales': 'Gestión del equipo comercial',
    'Transportistas': 'Administración de transportistas',
    'Prefijos Transportistas': 'Configuración de zonas por código postal',
    'Productos': 'Catálogo y gestión de productos',
    'Variantes de Producto': 'Gestión de variantes y opciones de productos',
    'Productos Especiales': 'Productos con características especiales',
    'Eventos': 'Registro y seguimiento de eventos del sistema',
    'Canales Telegram': 'Configuración de notificaciones Telegram',
    'Logs': 'Registro de actividades del sistema',
    'Ajustes': 'Configuración personal y del sistema'
  };
  
  return descriptions[moduleName] || 'Módulo del sistema ERP';
};